import React from "react";

const ComponentName = (props: any) => {
  return (
    <div>
      <ul className="pl-3">
        <li>
          Leave cannot be claimed as a matter of right. Sanctioning of any leave
          purely a discretion of Sanctioning authority. While granting leaves,
          sanctioning authority must ensure that official work is not hampered.
        </li>
        <li>
          Leave should be applied prior of leave period and applicant to ensure
          that leave has been sanctioned prior to proceeding on leave otherwise
          employee may be treated as absent and necessary salary deduction /
          disciplinary action may be taken.
        </li>
        <li>
          Sanctioned leave can be cancelled at any point of time BY MANAGEMENT
          and employee can be called back to join duties IMMEDIATELY.
        </li>
      </ul>
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          id="defaultCheck1"
          onClick={props.onSubmit}
        />
        <label className="form-check-label" htmlFor="defaultCheck1">
          I have read and understood the above instructions
        </label>
      </div>
      {/* <div className="row">
                    <div className="col-md-9"></div>
                    <div className="col-md-3"></div>
                </div> */}
    </div>
  );
};

export default ComponentName;
